import { Box } from '@zillow/constellation-10';
import { ReactNode } from 'react';
import { css } from '@/styled-system/css';
import { BaseSkeleton } from './BaseSkeleton';

export type SkeletonLineProps = {
    /**
     * What width to render the line as. By default the line will consume full width of the parent.
     */
    width?: string;
    marginY?: string;
    children?: ReactNode;
};

export const SkeletonLine = ({ width, marginY, children }: SkeletonLineProps) => (
    <BaseSkeleton>
        <Box
            className={css({
                width: width ?? '100%',
                marginTop: marginY,
                marginBottom: marginY,
                height: '1.5em',
                borderRadius: 'radii.sm',
            })}>
            {children}
        </Box>
    </BaseSkeleton>
);
